import {
  OnInit,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NgbActiveModal,
  NgbDateStruct,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from 'src/environments/environment';
import { BookTimingModalComponent } from '../../book-timing-modal/book-timing-modal.component';

import Swal from 'sweetalert2';
import moment from 'moment';
import * as CryptoJS from 'crypto-js';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { HttpClient } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { filter, Subscription, timer } from 'rxjs';
import { User } from 'src/app/shareModule/models/user.model';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { DOCUMENT } from '@angular/common';
import e from 'express';
import { ImageModalComponent } from 'src/app/shareModule/component/chat/chatbot/image-modal.component';
import { LinkShareComponent } from '../../link-share/link-share.component';
import { TagSelectorComponent } from '../../community/tag-selector/tag-selector.component';
import { stat } from 'node:fs';
import { MarketplacePageComponent } from '../marketplace.component';

declare const google: any;
@Component({
  selector: 'app-view-product-details',
  templateUrl: './view-product-details.component.html',
  styleUrls: [
    './view-product-details.component.scss',
    '../marketplace.component.scss',
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewProductDetailsComponent implements OnChanges, AfterViewInit, OnDestroy, OnInit {
  @Input() addProductComponent?: any = null;
  @Input() modal: any;

  @Input() productData: any;
  @Input() productLoader: boolean | null = false;
  @Output() updated = new EventEmitter<any>();


  public isShowingMoreVariants = false;
  /***************************** Code related to similar products  ****************************/
  @ViewChild('seeProductList')
  seeProductList: TemplateRef<any>;
  public currentModaRef?: NgbModalRef | null = null
  public searchProds = [];


  public openSimilarProducs(type) {
    this.productListTitle = ' Similar Products'
    this.productListIcons = 'fa-solid fa-handshake';
    this.auth
      .fetchProductsBasedOnTypes({ types: Array.from([type.id]) })
      .subscribe({
        next: (data: any) => {
          this.searchProds = data.data;
          this.isSearchProductsOnBookmark = false;
          this.currentModaRef = this.modalService.open(this.seeProductList, { size: 'md' });
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error something went wrong while fetching ');
        },
      });

  }
  /******************************************************************************************/
  /**************************** Code related to similar products and swiper for that ********/
  private _loadSameCategoryProducts() {
    if (this.similarProducts?.length) {
      return; //cause can be passed from popup to product page
    }
    this.customerService.getMemberShopProductList({ categoryId: this.productData?.categoryId, limit: 5, includeTypes: true })
      .subscribe({
        next: data => {
          if (!Array.isArray(data?.body?.data)) {
            return;
          }

          this.similarProducts = data?.body?.data?.filter(prod => prod && prod.id != this.productData?.id);
          this._loadMoreInfos();
        },
        error: console.error
      })

  }

  @Input()
  public similarProducts = []


  /******************************Types and Faqs *****************************/
  public faqsExist = true
  public typesExist = true
  public isInitDone = false;
  public carOptions = {
    slidesPerView: 1,
    //spaceBetween: 10,
    initialSlide: 1,
  };

  /************************************************************************* */

  //public ownerTelegramUsername: any = 0;
  public appUserId: any = 0;
  public sellerInfo: SafeHtml;
  public store_link_prefix: any = 'fusionapp.store';
  public default_store_link_prefix: any = 'fusionapp.store';
  public isTypeReferral: any;
  public refer_friend_link: any;
  public imgUrl = environment.ImageUrl;
  public suggestionBase64: any = null;
  public productSuggestions: any = [];
  public type: string = '';
  public memberMessage: string = '';
  public reportType: string = 'Spam';
  public suggestionAttachment: any = null;
  public errorChatURL: boolean = false;
  public messsage: string = '';
  public isMessageSent: boolean = false;
  public isBookNowBox: boolean = false;
  public isMessageBox: boolean = false;
  public profileInfo2: any;
  public profile: any = {};
  public memberProductList: Array<any> = [];
  public endTime: any = '';
  public timer: any = null;
  public isLogin: any = 0;
  public screenWidth: any = 0;
  public today = new Date();
  public bookNowBoxMesssage: string = '';
  public isLoading: boolean = false;

  //public tabsRecommend: any = [];
  public maps: any = {};
  lat: number = 1.3521;
  lng: number = 103.8198;
  map: any;
  geocoder: any;
  marker: any;
  postalCode: string = '';

  private modalRef: any;
  public user: any;
  public isUserDisabled: boolean = false;
  public ownerTelegramUserName = '';
  public isExpandedDescription: boolean = false;
  @ViewChild('product_content') product_content: ElementRef;
  productSeeMore: boolean = false;
  canScrollDescription: boolean = false;

  public iconsSwiperOptions = {
    //slidesPerView: 4, 
    //spaceBetween: 10,
    nested: true

  }

  public specialTags = new Set(['Preferred', 'Top Seller']);

  public carouselOptions: any = {
    pagination: false,
    loop: true,
    nested: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: true,
    },
    touchStartPreventDefault: false,
    passiveListeners: false,

  };
  //////////////////////////////// Code related to bookmarks ///////////////////////////////////
  public addProductToBookmarks(prod) {
    const rv = this.local.addProductToBookMark(prod);
    if (rv === -1) {
      this.toastr.info("Maximum bookmark length")
    }
  }
  public removeProductFromBookmarks(prod) {
    this.local.removeProductFromBookMarks(prod);
  }
  public bookmarkedProductsIds = new Set();
  public bookMarkSubscrption?: Subscription | null = null;
  ////////////////////////////////////////////////////////////////////////////////////////



  public get productHasFAQ(): boolean {
    return (typeof this.productData?.faqInfos == 'string' && this.productData?.faqInfos?.length > 3) ||
      (Array.isArray(this.productData?.faqInfos) && this.productData?.length)
  }
  constructor(
    private http: HttpClient,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    public modalService: NgbModal,
    private clipboard: Clipboard,
    private memberNotificationService: MemberNotificationService,
    private _sanitizer: DomSanitizer,
    private sharedService: SharedService,
    public roleService: RoleService,
    private customerService: CustomerService,
    private router: Router,
    private store: Store<AppState>,
    private seoService: SeoService,
    private renderer2: Renderer2,
    private route: ActivatedRoute,
    // private activeModal: NgbActiveModal,
    @Inject("WINDOW") private window: any,
  ) {
    this.screenWidth = this.window.innerWidth;
    //this.checkIfLogin();

    this.store
      .pipe(select(selectUser))
      .pipe(filter((user) => !!user))
      .subscribe((response: User) => {
        this.profileInfo2 = response;
        ////////console.log('profile is', this.profileInfo2)
      });

    if (this.productData?.seller && !this.productData?.seller?.w_phone_number) {
      this.productData.seller.buyerContact = 1;
    }



    setTimeout(() => {
      this.checkDescriptionScroll();
    }, 4000)
    // setTimeout( () =>this.getTelegramUsernameOfUser(this.productData?.appUser?.id), 800);
  }

  openSuggestionPopup(productData) {
    const ref = this.modalService.open(TagSelectorComponent, { size: 'sm', windowClass: 'tags-modal', centered: true });
    ref.componentInstance.productId = productData.id
    return ref
  }
  openSuggestionPopupAndRefresh(productData) {
    this.openSuggestionPopup(productData).closed.subscribe(() => {
      this._loadMoreInfos();
    })
  }
  public removeTagFromProduct(tag) {

    this.auth.removeTagFromProduct(tag.tag, this.productData.id)
      .subscribe({
        next: () => {
          this._loadMoreInfos();
          this.toastr.success("Removed tag")
          tag.isAddedByMe = !tag.isAddedByMe;
          tag.addCount -= 1;
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something went wrong while adding tag')
        }
      });

  }
  public addTagToProduct(tag) {
    //////console.log({ tag })
    this.auth.addTagToProduct(tag.tag, null, this.productData.id, this.isAdmin()).subscribe({
      next: () => {
        this.toastr.success("Added tag")
        tag.addCount += 1;
        tag.isAddedByMe = !tag.isAddedByMe;
        this._loadMoreInfos();

      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Something went wrong while adding tag')
      }

    })

  }
  public tags = []
  private loadTags(productData) {
    if (!productData) {
      console.warn('error productData is invalid', productData)
    }


    this.auth.getTagsOfProduct(productData?.id).subscribe(
      {
        next: (data: any) => {
          productData.tags = data.data
        },
        error: console.error
      }
    )
  }

  public closeActiveModal() {
    this.modalService.dismissAll();
  }
  public productListTitle = 'Similar Products';
  public productListIcons = 'fa-solid fa-bookmark';
  private editProductIdSubjectSubscirption: Subscription | null = null;
  public searchProductSelected(isSelectedNow, productData) {
    if (this.isSearchProductsOnBookmark) {
      if (isSelectedNow) {
        this.local.addProductToBookMark(productData);
        this.toastr.success("Added to bookmarks")

      } else {
        this.local.removeProductFromBookMarks(productData)
        this.toastr.success("Removed from bookmarks")
      }

    }
  }
  public openSaveBookMarks() {
    this.productListTitle = ' Bookmarked Products';
    this.productListIcons = 'fa-solid fa-bookmark';
    this.searchProds = this.local.bookMarkedProducts.value;
    this.isSearchProductsOnBookmark = true;
    this.modalService.open(this.seeProductList, { size: 'md' });

  }
  ngOnInit(): void {
    this.mainProductData = this.productData;
    this.loadTypeOfProduct(this.productData);
    if (this.sharedService.isBrowser()) {
      // setTimeout(() =>this.loadTags(), 2000);
      // setTimeout(() =>this.loadRatings(), 2000);
      this.isLoading = true;
      this.bookMarkSubscrption = this.local.bookMarkedProducts.asObservable().subscribe((val) => {
        //console.log({val})
        this.bookmarkedProductsIds = new Set(val.map(b => b.id))

      })

      this.editProductIdSubjectSubscirption = this.sharedService.editProductIdSubject.subscribe(
        {
          next: productId => {
            const userId = this.local.getUser()?.id;
            if (((productId == this.productData?.id) || (!productId && this.isPopup)
              &&
              userId == this.productData?.memberId
            )) {
              this.editMemberProduct();
            }
          }
        }
      )
    }



    if (this.sharedService.isBrowser()) {
      this._loadMoreInfos();
    }
    this.checkIfLogin();
    if (this.beginExplanationTimeout) {
      clearTimeout(this.beginExplanationTimeout);
    }
    this.beginExplanationTimeout = setTimeout(() => {
      if (this.sharedService.isBrowser()) {
        this.beginExplanationInterval()

      }

    }, 1_000) //CHANGE_BACK 1_000

  }
  private nullCheck(value: any): string {
    if (value === null || value === 'null' || value === '') {
      return '';
    }
    return value;
  }
  public isTherePrice(productData) {
    return ((productData?.memberShopProductsVariations?.length > 0 && productData?.type != 'promote')
      || productData?.["foodSpecs"]?.length > 0 && productData?.["foodSpecs"].some(x => x.key != '$0' && x.key != '0'))
  }
  private _loadTabsRecommends(productData) {
    productData.tabsRecommend = [];
    if (this.productData.enableMemberShop) { //if main one is enabled the others are too
      productData["tabsInfo"] = [
        // {
        //   title: "Price",
        //   icon: "fa-solid fa-dollar-sign",
        //   condition: ( (productData.memberShopProductsVariations?.length > 0 && productData.type != 'promote') 
        //   || productData?.["foodSpecs"]?.length > 0 && productData?.["foodSpecs"].some(x => x.key != '$0'  && x.key != '0'))// && productData.type != "promote",
        // },
        {
          title: "Info",
          icon: "fa-solid fa-circle-info",
          condition: productData?.description != "" || ((productData?.memberShopProductsVariations?.length > 0 && productData?.type != 'promote')
            || productData?.["foodSpecs"]?.length > 0 && productData?.["foodSpecs"].some(x => x.key != '$0' && x.key != '0'))
        },
        {
          title: "Detail",
          // icon: 'fa-solid fa-circle-info',
          condition: productData.charges != "" && productData.charges != undefined && productData.charges != "null" && productData.charges != "-",
        },

        {
          title: "Rent",
          // icon: 'fa-solid fa-circle-info',
          condition: productData?.type == "rental" && (productData?.depositAmt || productData?.estimateValue || productData?.warranty),
        },
        {
          title: "Contact",
          icon: "fa-solid fa fa-phone",
          condition: productData?.type == "promote" && (productData?.roleName?.includes("SUPER SELLER") || productData?.roleName?.includes("ADMIN")) && (this.nullCheck(productData?.shoutContactRelation) || this.nullCheck(productData?.shoutWebsite)),
        },
        {
          title: productData?.subRegionName?.trim() ?? "Location",
          icon: "fa-solid fa-location",
          condition: (productData?.type == "promote" && productData?.latLong != '{}' && productData?.latLong != null)
            || (productData?.type != 'promote' && productData?.appUser?.postalCode != null)
        }
      ];


      productData.tabsRecommend = [
        {
          title: `Experiences(${productData?.xpCount ?? 0})`,
        },
        {
          title: "Promo",
          condition: productData?.productMoreServices?.length > 0
        },
        {
          title: "Profile",
          //  icon: 'fa-solid fa-user'
        },
        {
          title: 'Discuss' + (productData?.enableMemberShop && productData?.forum?.repliesCount ? `(${productData?.forum?.repliesCount})` : ''
          ),
        },
        {
          title: "More Products",
          // icon: '',
          condition: productData?.more_products_data?.length > 0,
        },
        {
          title: "Socials",
          // icon: 'fa-solid fa-star',
          condition:
            productData["sellerInformation"]?.fbReviewUrl ||
            productData["sellerInformation"]?.carousellReviewUrl ||
            productData["sellerInformation"]?.googleReviewUrl ||
            productData["sellerInformation"]?.websiteUrl ||
            productData["sellerInformation"]?.instagramUrl ||
            productData["sellerInformation"]?.fbUrl,
        },
        {
          title: 'FAQ',
          condition: this.productHasFAQ,
        }
      ];

    }
    //console.log(productData?.name, productData?.tabsRecommend)

  }
  private _loadMoreInfos() {
    //console.trace('_loadMoreInfos', this.similarProducts)

    for (const prod of [this.productData, ...this.similarProducts]) {
      if (!prod) {
        console.warn('invalid prod', prod)
        continue
      }
      if (prod && this.mainProductEnableMemberShop !== undefined) {
        prod.enableMemberShop = this.mainProductEnableMemberShop;
        this.loadOtherImagesOfProduct(prod)
        this.loadTags(prod);
        this.loadTypeOfProduct(prod);
        this.loadRatings(prod);
        this._loadTabsRecommends(prod)
      }
    }



    this.isLoading = false;


  }
  public get isPopup(): boolean {
    return this.window.location.href.includes('?product')

  }


  private closeExplanation() {
    this.sharedService.showAIExplanationForProductSubject.next({ explainText: '', closeAll: true })
  }
  openCorrectedSite(url: string) {
    ////////console.log({url})
    if (url?.trim()) {
      Swal.fire({
        title: "Open link",
        text: 'Open link a in a new tab?',
        icon: 'info',
        showCancelButton: true,
      }).then(res => {
        if (res.isConfirmed) {
          this.window.open(this.correctSite(url), '_blank')
        } else {

        }
      })
    }

  }
  ngOnDestroy(): void {
    this.editProductIdSubjectSubscirption?.unsubscribe();
    this.bookMarkSubscrption?.unsubscribe();
    if (this.sharedService.isBrowser()) {

      //////console.log('destroy called')
      const synth = window.speechSynthesis;
      synth.cancel();

      this.disposeExplanationInterval();
      this.closeExplanation()
      if (this.productData) {
        this.productData.ratings = []
      }


    }

  }
  public currentProductTogglePopuplarInSubRegion() {
    this.auth.toggleProductIsPopuplarInSubRegion(this.productData?.id)
      .subscribe({
        next: () => {
          this.toastr.success("Changed");
        },
        error: err => {
          this.toastr.error(err.error.message);
        }
      })
  }

  public get isVerySmall() {
    return this.sharedService.isBrowser() && window.innerWidth <= 434
  }

  // public otherRatingBadges = []
  private loadRatings(pd) {

    if (!pd) {
      return
    }
    pd.ratings = []
    pd.otherRatingBadges = []

    if (pd && pd.isPopuplarInSubRegion) {
      //console.log('product is popular in subregion')
      pd.otherRatingBadges.push({
        icon: 'adopt.png',
        topText: 'Popular in ',
        bottomText: pd.subRegionName ?? '',
        isNormalBadge: true
      })

    }

    if (pd && pd['seller_info']) {
      ////console.log('loading ratings on', pd.name)



      let sellerInfo = pd['seller_info'];
      ////////console.log('seller_info is in productData', sellerInfo) //DELETE LATTER
      ////////console.log('seller info is ', sellerInfo)
      if (!sellerInfo) {
        console.warn('no sellerinfo')
        return;
      } else {
        if (typeof sellerInfo == 'string') {
          sellerInfo = JSON.parse(sellerInfo)
        }
        ////console.log(pd.name, sellerInfo)
      }



      if (sellerInfo['googleReviewRating']) {
        pd.ratings.push({
          icon: 'ggle.png',
          name: 'Google Reviews',
          ratingUrl: sellerInfo.googleReviewUrl,
          rating: sellerInfo.googleReviewRating,
          counts: sellerInfo.googleReviewCount
        })
      }
      if (sellerInfo['fbReviewRating']) {
        pd.ratings.push({
          icon: 'facebook.png',
          name: 'Facebook Reviews',
          ratingUrl: sellerInfo.fbReviewUrl,
          rating: sellerInfo.fbReviewRating,
          counts: sellerInfo.fbReviewCount
        })
      }

      if (sellerInfo['carousellReviewRating']) {
        pd.ratings.push({
          icon: 'carousell.png',
          name: 'Carousel Reviews',
          ratingUrl: sellerInfo.carousellReviewUrl,
          rating: sellerInfo.carousellReviewRating,
          counts: sellerInfo.carousellReviewCount
        })
      }

      const otherToolTips = `Claims are determined from various sources such as:
      1. Online Reviews 
      2. Real-life Testimonials 
      3. Customer feedback surve`

      if (sellerInfo['superDealRating']) {
        pd.otherRatingBadges.push({
          icon: 'super_deal_1.png',
          name: 'Super Deal',
          rating: sellerInfo.superDealRating,
          text: sellerInfo.superDealText,
          toolTip: otherToolTips
        })
      }

      if (sellerInfo['bestPriceRating']) {
        pd.otherRatingBadges.push({
          icon: 'best_price_1.png',
          name: 'Best Price',
          rating: sellerInfo.bestPriceRating,
          text: sellerInfo.bestPriceText,
          toolTip: otherToolTips
        })
      }

      if (sellerInfo['highQualityRating']) {
        pd.otherRatingBadges.push({
          icon: 'high_quality_1.png',
          name: 'Hight Quality',
          rating: sellerInfo.highQualityRating,
          text: sellerInfo.highQualityText,
          toolTip: otherToolTips
        })
      }




    }
    if (pd) {
      pd.ratings = structuredClone(pd.ratings)
    }
    if (pd.otherRatingBadges) {
      pd.otherRatingBadges = structuredClone(pd.otherRatingBadges)
    }


    ////////console.log('ratings are ', this.ratings)
  }

  private abortController: AbortController | null = null;
  private fetchSummarySubsctiption: Subscription | null = null


  private explanationInterVal = null;
  private explanations = []
  private currentExplantaionIndex = 0
  private showNextExplanation() {
    this.sharedService.showAIExplanationForProductSubject.next({
      explainText: this.explanations[(this.currentExplantaionIndex++) % this.explanations.length],
      isExplanationProductClaimable: this.showReferProductIcon
    });

  }
  private beginExplanationInterval() {
    if (this.explanationInterVal) {
      clearInterval(this.explanationInterVal);
    }
    this.fetchSummarySubsctiption?.unsubscribe();

    this.fetchSummarySubsctiption = this.customerService.getProductSummary(
      this.productData?.id,
      !(this.productData && typeof this.productData === 'object' && 'appUser' in this.productData)
    ).subscribe({
      next: (data) => {
        this.fetchSummarySubsctiption = null;

        this.explanations = data.data;
        if (!this.explanations.length) {
          console.warn('No explanations for product found!')
          return;
        }

        this.showNextExplanation()
        this.explanationInterVal = setInterval(() => {
          this.showNextExplanation()
        }, 15_000) //CHANGE_BACK 10_000

      },
      error: err => {
        console.error(err);
        this.fetchSummarySubsctiption = null;
      }
    });


  }
  private disposeExplanationInterval() {
    if (this.beginExplanationTimeout) {
      clearTimeout(this.beginExplanationTimeout);
      this.beginExplanationTimeout = null;
    }
    this.fetchSummarySubsctiption?.unsubscribe(); //if any calls tot he previous product just don't show it anymore
    if (!this.explanationInterVal) return;
    clearInterval(this.explanationInterVal)
    this.explanationInterVal = null;
  }

  private beginExplanationTimeout = null;
  ngAfterViewInit(): void {

  }

  public get isThereValidCropInformation(): boolean {
    const cropInfo = this.productData?.mainImageCropInformation;
    if (!cropInfo || cropInfo == 'null' || cropInfo == 'undefined') {
      return false;
    }
    try {
      const data = (typeof cropInfo == 'object') ? cropInfo : JSON.parse(cropInfo);
      const { isYAxisTheOneThatIsLocked, offsetRatio, imageAspectRatio } = data;
      const neededData = [isYAxisTheOneThatIsLocked, offsetRatio, imageAspectRatio]
      return !neededData.includes(null) && !neededData.includes(undefined)
    } catch (e) {
      return false;
    }
  }



  public openProductPage(productData) {
    //console.log({productData})
    //[routerLink]="['/product', productData?.slug]"
    this.router.navigate(['/product', productData?.slug], {
      state:
        { passedProductData: structuredClone(productData), similarProducts: this.similarProducts ?? [] }
    }
    )

  }

  public isReading = false;
  private nowReadingText = ''

  public pause() {
    const synth = speechSynthesis;

    if (synth.speaking && !synth.paused) {
      ////////console.log("Pausing read");
      speechSynthesis.pause()
      this.isReading = false;
    } else {
      //////console.log("Cannot pause, either not speaking or already paused");
    }
  }


  public async read(text) {
    const synth = window.speechSynthesis;
    if (synth.speaking && this.nowReadingText != text) {
      await synth.cancel();
    }
    if (synth.speaking && this.nowReadingText === text) {
      await synth.resume();
    }
    this.nowReadingText = text;


    const userAgent = navigator.userAgent;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = 1;


    const voices = speechSynthesis.getVoices()

    let voice = null;

    if (userAgent.includes("Chrome") && !userAgent.includes("Edg") && !userAgent.includes("OPR") && !userAgent.includes("Brave")) {
      //////console.log('choosing a device on chrome or edge')
      const cand = voices.find(voice => voices.find(voice => voice.name.toLowerCase().includes("moira") || voice.lang === "en-SG") || voice.name.includes("Female") || voice.lang.includes("en") && voice.name.includes("Google"));
      if (cand) {
        voice = cand;
      }
      //////console.log('Picked voice for chrome ', voice)
    }
    if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
      const cand = voices.find(voice => voice.name.includes("Siri"));
      if (cand) {
        voice = cand;
      }

    }
    if (voice) {
      utterance.voice = voice;

    }

    this.isReading = true;
    speechSynthesis.speak(utterance,);
    utterance.onend = () => {
      this.isReading = false;
    }


  }

  public get isVerified(): boolean {
    return this.productData?.productVerficationsList && this.productData?.productVerficationsList?.length > 0
  }
  checkDescriptionScroll() {
    setTimeout(() => {
      const contentHeight =
        this.product_content?.nativeElement.scrollHeight;
      if (contentHeight > 12 * 16) {
        this.canScrollDescription = true;
        this.productSeeMore = false;
      }
    }, 500);
  }
  public isSearchProductsOnBookmark = false;

  public productSwiperChanged(swiper) {
    if (swiper.activeIndex == 0) {
      this.productData = this.mainProductData
    } else {
      this.productData = this.similarProducts[swiper.activeIndex - 1] ///this way all code does not need change
    }

    this.checkDescriptionScroll();

  }

  public showingPop = false;
  public goToProduct(prod) {
    if (prod && this.mainProductEnableMemberShop !== undefined) {
      prod.enableMemberShop = this.mainProductEnableMemberShop;
      this.loadOtherImagesOfProduct(prod)
      this.loadTags(prod);
      this.loadTypeOfProduct(prod);
      this.loadRatings(prod);
      this._loadTabsRecommends(prod)
      this._loadTabsRecommends(prod)
    }

    this.productData = prod;
    this.currentModaRef?.close();
  }

  private readonly onChangeListeners: any = [];
  public mainProductData = null;
  ngOnChanges(changes: SimpleChanges): void {

    if (changes['productData']) {
      this.mainProductData = this.productData;
      this.loadTypeOfProduct(this.productData);
      this._loadSameCategoryProducts();
      this._loadMoreInfos()


      if (this.productData?.enableMemberShop) {
        //////console.log('forumData', JSON.stringify(this.productData?.forum),this.productData?.forum )
        this._loadTabsRecommends(this.productData);

      }
    }


  }

  async initMap() {
    this.geocoder = new google.maps.Geocoder();
    await this.getLatLongByPostalCode()
    setTimeout(() => {
      this.map = new google.maps.Map(document.getElementById('map_biz'), {
        center: { lat: this.lat, lng: this.lng },
        zoom: 14,
        restriction: {
          latLngBounds: {
            north: 1.47,
            south: 1.22,
            east: 104.05,
            west: 103.62,
          },
          strictBounds: true,
        },
      });


      this.geocodePostalCode();
    }, 100);
  }

  latLongUser: any = {}
  positionString = '';
  async getLatLongByPostalCode() {
    const res = await this.local.getLatLongByPostalCode(this.productData?.appUser?.postalCode)
    this.latLongUser = res;
    //////console.log({res})
    return res

    // return new Promise((resolve, reject) => {
    //   this.geocoder.geocode(
    //     { address: this.productData?.appUser?.postalCode },
    //     (results: any, status: any) => {
    //       if (status === 'OK') {
    //         const location = results[0].geometry.location;
    //         const latLong = { lat: location.lat(), lng: location.lng() };
    //         this.latLongUser = latLong;
    //         resolve(latLong);
    //       } else {
    //         reject(status);
    //       }
    //     }
    //   );
    //});
  }

  markers: any = [];
  placeMarkerAndPanTo(latLng: any, userLatLong: any = {}): void {
    if (!this.markers) {
      this.markers = [];
    }
    this.markers.push(
      new google.maps.Marker({
        position: this.productData?.type == 'promote' ? latLng : this.latLongUser,
        map: this.map,
        restriction: {
          latLngBounds: {
            north: 1.47,
            south: 1.22,
            east: 104.05,
            west: 103.62,
          },
          strictBounds: true,
        },
      })
    );
    // Create a dummy latLong for the second marker
    if (userLatLong?.lat) {
      const dummyLatLng = { lat: userLatLong.lat, lng: userLatLong.lng };
      this.markers.push(
        new google.maps.Marker({
          position: dummyLatLng,
          map: this.map,
          icon: {
            path: 'M0,-5 L-5,5 L5,5 Z',
            scale: 1, // Reduced scale for a smaller icon
            strokeColor: '#ff834f', // pink color
            strokeWeight: 2,
            fillColor: '#ff834f', // pink color
            fillOpacity: 0.8,
          },
          restriction: {
            latLngBounds: {
              north: 1.47,
              south: 1.22,
              east: 104.05,
              west: 103.62,
            },
            strictBounds: true,
          },
        })
      );
    }
    this.map.panTo(this.productData?.type == 'promote' ? latLng : this.latLongUser);
  }

  async geocodePostalCode(): Promise<void> {
    console.trace('getting pos for', this.productData?.name)
    const postalCode = this.productData?.postalCode || this.productData?.appUser?.postalCode;
    if (!postalCode) {
      console.warn('postalCode is falsy for', this.productData?.name)
    }
    if (postalCode) {
      // this.geocoder.geocode(
      //   {
      //     address: this.postalCode,
      //     componentRestrictions: {
      //       country: 'SG'
      //     }
      //   },
      //   (results: any, status: any) => {
      //     if (status === 'OK') {
      try {
        const location = await this.local.getLatLongByPostalCode(postalCode);
        console.log('locations is ', location)


        this.geocoder.geocode({ location }, (reverseResults: any, reverseStatus: any) => {
          ////////console.log(results[0])
          if (reverseStatus === 'OK' && reverseResults.length) {
            const addressComponents = reverseResults[0].address_components;

            const routeComponent = addressComponents.find((component: any) =>
              component.types.includes('route')
            );

            const streetName = routeComponent ? routeComponent.long_name : null;
            this.positionString = streetName;
          }
        });
        const latLong = location;
        this.placeMarkerAndPanTo(
          JSON.parse(this.productData?.latLong),
          latLong
        );
      } catch (e) {
        console.warn(e)
      }

    }

    else this.placeMarkerAndPanTo(JSON.parse(this.productData.latLong));
  }

  deleteReport(type) {
    this.local.alertConfirm({})
      .then((resp) => {
        if (resp.isConfirmed) {
          this.customerService.deleteReportProduct({
            productId: this.productData.id,
            type: type
          }).subscribe((resp) => {
            this.productData.reports = this.productData.reports.filter((row: any) => row?.type != type)
            this.toastr.success(resp.message);
          })
        }
      })
  }

  public correctSite(site: string) {
    if (site?.trim()) {
      if (site?.startsWith('https') || site?.startsWith('http')) {
        return site
      }
      if (site?.startsWith('www')) {
        return 'https://' + site
      }
      return 'https://www.' + site

    }
    return ""

  }
  public get prodSite(): string {
    return this.correctSite(this.productData?.shoutWebsite)

  }
  public clickTab(index: any) {
    if (index == 4) {
      if (this.productData?.latLong) this.initMap();
    }
  }
  public get mainProductEnableMemberShop(): boolean {
    return this.mainProductData?.enableMemberShop
  }
  private _toggleVerifyLike(item) {
    if (!item.haveILiked) {
      this.auth.toggleVerifyReaction(item.id).subscribe({
        next: () => {
          // try fix this
          if (item.haveILiked == null || item.haveILiked == undefined) {
            item.likeCounts = 0
          }
          if (!item.haveILiked) {
            ////////console.log('item.likeCounts  wooooo', item)
            item.likeCounts += 1
            item.haveILiked = true;

          } else {
            item.likeCounts -= 1
            item.haveILiked = false;
          }
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Something wen wrong')
        }
      })

    }



  }
  public toggleVerifyLike(item, productData) {
    if (!this.isLogin) {
      this.showLoginError('like a verification')
      return;
    }

    this.openSuggestionPopup(productData).result.then(
      (res) => { if (res.added) this._toggleVerifyLike(item); this._loadMoreInfos(); }
    )

  }

  public checkIfLogin(): void {
    this.local.getUserDetailsObserver().subscribe((user) => {
      this.isUserDisabled = user?.isDisabled;
      this.appUserId = user?.id;
      this.isLogin = user ? 1 : 0;
      this.postalCode = user?.postalCode;
    });
  }

  public handleError(event: any): void {
    (
      event.target as HTMLImageElement
    ).style.backgroundImage = `url('../../../../../../assets/images/shop/default.png')`;
  }

  copyReferralLink() {
    this.clipboard.copy(this.refer_friend_link);
    this.toastr.success('Referral Link Copied');
  }
  public getMemberProductList() {
    this.customerService
      .getAllShopProduct({
        categoryId: '',
        subCategoryId: '',
      })
      .subscribe(
        (response: any) => {
          this.memberProductList = response.body.filter(
            (i: any) =>
              i.memberId == this.local.getUser().id &&
              i?.type == this.productData?.type
          );
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  private removeImageFromHtml(html: string): string {
    if (typeof DOMParser !== "undefined") {
      const domParser = new DOMParser();
      const docu = domParser.parseFromString(html, 'text/html');
      docu.querySelectorAll('img').forEach((img) => img.remove());

      return docu.body.innerHTML;
    } else {
      return html;
    }
  }

  // public productTypes = new Set();
  // public currentProductCategoryAvailableTypes = []
  private loadTypeOfProduct(productData) {
    if (!productData) {
      console.warn('productData is empty', productData)
      return;
    }
    const productId = productData?.id;
    if (productId) {
      this.auth.getTypesOfProduct(productId).subscribe({
        next: (data: any) => {

          productData.productTypes = new Set(data.data.map((t) => t.typeId));
          productData.currentProductCategoryAvailableTypes = data.others;
        },
        error: console.error,
      });


    }
  }
  public formattedText(productData, value) {
    if (!productData) {
      return;
    }
    return this.removeImageFromHtml(
      productData?.[value]
        ?.replace(/\n/g, '<br>')
        .replace(/<b>/g, '<b style="font-weight: 700">')
    );
  }

  deleteProductsAttachment() {
    if (this.productData.attachmentProductsKey) {
      this.auth
        .deleteProductsAttachment(this.productData.attachmentProductsKey)
        .subscribe((response: any) => {
          this.modalRef ? this.modalRef.close() : '';
          this.toastr.success(response.message);
          this.memberNotificationService.clearNotification();
        });
    }
  }

  isAdmin = () => this.roleService?.roles?.userType.includes('ADMIN')


  private favouriteProd(item: any, status: boolean = true) {

    let formData = {};

    if (item.foodId != null) {
      item.id = item.foodId;
    }
    if (this.productData?.enableMemberShop) {
      formData = {
        member_product_id: item.id,
        isAdmin: this.isAdmin(),
      };
    } else {
      formData = {
        foodId: item.id,
        isAdmin: this.isAdmin(),
      };
    }
    //formData['tagName'] = data;for
    formData = { ...formData, }

    this.auth.marketplace_favorite_product(formData).subscribe(() => {
      item.isFavorite = !item?.isFavorite;
      if (item?.isFavorite && status) {
        // this.filteredProducts[category][index].foodFavoritesCount += 1
      } else {
        if (this.profile?.favorites)
          this.profile.favorites = this.profile?.favorites?.filter(
            (row: any) => row.foodId != item.id
          );
        // this.filteredProducts[category][index].foodFavoritesCount -= 1
      }

      if (status) {
        this.updated.emit('getProductList');
      }
      this.memberNotificationService.getNotification();
      this._loadMoreInfos();
    });


  }

  handleFavoriteProduct(item: any, status: boolean = true) {
    if (this.isLogin) {
      if (!item.isFavorite) {
        this.local.confirmYesNo({ title: 'Favourites', text: 'Add to Favourites ', icon: 'question' })
          .then(
            c => {
              if (c.isConfirmed) {
                this.favouriteProd(item)
              }
            }
          )
      }
      else {
        this.favouriteProd(item)
      }
    }
    else {
      this.showLoginError('add product in favourites')
    }



  }


  handleChangeRecommend(action) {
    if (!this.productData?.recommendedPins || action.reset) {
      this.productData.recommendedPins = []
    }

    this.productData.recommendedPins.push(action)
  }

  changeShowImageProduct(productData, image: string) {
    if (!productData) {
      return;
    }
    productData['food_image_active'] = image;
  }

  async onChangeBookNowMessage(e: any) {
    this.bookNowBoxMesssage = e.target.value;
  }

  @Input()
  public linkRfererUserId: string = ''


  @ViewChild('whyReferExplanation') whyReferExplanationModal: ElementRef;
  public showReferalUnlockExplaination() {
    this.modalService.open(this.whyReferExplanationModal, {
      size: "md",
    })
  }

  public get isMobile(): boolean {
    return this.sharedService.isBrowser() && window.innerWidth < 767;
  }
  public moduloIncreaseVerifiedRating() {
    if (!this.isAdmin()) {
      return;
    }
    this.auth.moduloIncreaseVerifiedRating(this.productData?.id).subscribe({
      next: () => {
        this.toastr.success("changed")
        this.productData.verifiedTagRating += 1;
        if (this.productData.verifiedTagRating > 3) {
          this.productData.verifiedTagRating = 1
        }
      },
      error: err => {
        this.toastr.error(err.error.message);
      }
    })

  }

  public claimPromoCode = ''
  public claimCurrentMoreSerive() {
    this.auth.claimMoreSerive(
      this.linkRfererUserId, this.selectedMoreService.id, this.claimPromoCode
    )
      .subscribe({
        next: (data: any) => {
          this.toastr.success(data.message)
          this.modalService.dismissAll();
        },
        error: (error: any) => {
          this.toastr.error(error.error.message)
        }
      })
  }


  @ViewChild('claimReferal') claimReferal: ElementRef;
  public selectedMoreService = null

  public claimMoreService(ms) {
    this.selectedMoreService = ms;
    this.modalService.open(
      this.claimReferal,
      {
        size: 'md'
      }
    )

  }

  async bookNow(
    productId,
    productName,
    sellerId,
    sellerName,
    sellerPhoneNumber
  ) {
    this.isLoading = true;

    this.auth
      .syncBooking({
        productId: productId,
        type: 0,
        sellerId: sellerId,
        buyerId: this.profileInfo2.id,
        payload: {
          productId,
          sellerPhoneNumber,
          productName,
        },
      })
      .subscribe(async (response: any) => {
        this.productData.remainingBook.push(response.body.bookings);
      });

    this.isLoading = false;
    this.isBookNowBox = false;
    this.isMessageSent = true;
    setTimeout(() => {
      this.isMessageSent = false;
    }, 2000);
  }

  openBookNowBox() {
    this.showAlertMessage('booking');
    // this.isBookNowBox = !this.isBookNowBox;
  }
  public floorRatting(rating, total) {
    ////////console.log(arguments)
    const div = Number(rating) / (Number(total) / 5)
    if (Number.isNaN(div)) {
      return 100;
    }
    return div * 100
  }

  async buyNow(
    productId,
    productName,
    sellerId,
    depositAmount,
    estimatedAmount
  ) {
    var productData = {
      productId: productId,
      productName: productName,
      depositAmount: depositAmount,
      estimatedAmount: estimatedAmount,
    };

    Swal.fire({
      // title: 'Are you sure?',
      text: 'Deposit is optional and dependent on the seller. Card will be put on hold, no charges will be made.',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Continue',
    }).then((result) => {
      if (result.isConfirmed) {
        var jsonproduct = JSON.stringify(productData);
        this.isLoading = true;
        let formData = new FormData();
        formData.append('id', this.appUserId); //todo this.appUserId
        formData.append('stripe_price_id', '1');
        formData.append('tokens', 'auth');
        formData.append('token', 'auth');
        formData.append('sub', jsonproduct);
        formData.append('notification_code', 'DEFAULT');
        formData.append('sub_type', '2');

        this.auth.create_stripe_checkout_url(formData).subscribe(
          (response: any) => {
            if (response.body.url != 'r') {
              this.window.location.href = response.body.url;
            } else if (response.message != '') {
              this.toastr.success(response.message);

              this.modalRef ? this.modalRef.close() : '';
            }
          },
          (e) => {
            if (e.status == 400) {
              this.toastr.error(e.error.message);
            }
          }
        );
      }
    });
    //if (!confirm('We will require you to add your crediit card for Rental')) {
    //   return;
    // }

    // Convert the JSON object to a JSON string
  }
  //public ratings = []

  showImage(src, descr = '') {
    const ref = this.modalService.open(ImageModalComponent, {
      size: "sm",
      windowClass: "image-modal",
    });
    ref.componentInstance.imageSrc = environment.ImageUrl + src;
    ref.componentInstance.descr = descr
    ref.closed.subscribe({
      next: () => {
        this.modalDismissAll();
      }
    })
  }

  async showAlertMessage(type: string = 'whatsapp') {
    if (!this.isLogin) {
      this.toastr.error('Please login first!');
      return false;
    }

    const isLogin = this.local.getUser();
    if (!isLogin) return this.toastr.error('Please Login First!');

    const user = this.productData.appUser ?? this.productData.seller;

    if (isLogin.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    const detail = this.productData;
    const typeFilter = type == 'whatsapp' ? 1 : 0;
    const check = detail.remainingBook.filter(
      (row: any) => row.productId == detail.id && row?.type == typeFilter
    );

    if (detail.remainingBook.length > 5) {
      this.toastr.error(
        'you have reached the maximum limit for sending messages'
      );
      return false;
    }

    if (this.remainingClickBook(typeFilter) == 0) {
      this.toastr.error(
        'you have reached the maximum limit for sending messages'
      );
      return false;
    }

    if (check.length > 0) {
      this.toastr.error('You can only message this person once per day');
      return false;
    }

    const label = type == 'whatsapp' ? 'Write Your Message' : 'Book Now';
    const data = await Swal.fire({
      title:
        '<span style="position: absolute;left: 20px;top: 10px;"><i class="fa-brands fa-whatsapp"></i></span>',

      html: `Are you sure you want to book product ${this.productData.name}?`,
      showCancelButton: true,
      confirmButtonText: `<i class="fa-solid fa-paper-plane"></i> ${type == 'whatsapp' ? 'Send' : 'Book'
        }`,
      cancelButtonText: '<i class="fa-solid fa-times"></i> Cancel',
    });

    if (data.isConfirmed) {
      Swal.fire({
        icon: 'info',
        title: 'Sending...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Simulate an API call
      this.sendData(type)
        .then(() => {
          Swal.close();
          this.toastr.success('Your message has been sent.');
        })
        .catch(() => {
          Swal.close();
          this.toastr.error('Something went wrong.');
        });
    }
  }

  // Simulated function to send data
  sendData(type: string): Promise<any> {
    return new Promise(async (resolve) => {
      if (type == 'whatsapp') {
        await this.sendMessage(
          this.productData.seller.first_name,
          this.productData.name,
          this.productData.seller.w_country_code,
          this.productData.seller.w_phone_number
        );
      } else {
        await this.bookNow(
          this.productData.id,
          this.productData.name,
          this.productData?.adminId ?? this.productData?.memberId,
          this.productData.seller?.first_name,
          this.productData.seller?.w_phone_number
        );
      }
      resolve('Success');
    });
  }

  async sendMessage(sellerName, productName, countryCode, phoneNumber) {
    if (this.messsage.length <= 0) {
      return;
    }

    this.isLoading = true;
    const data = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: `+65${phoneNumber}`,
      type: 'template',
      template: {
        name: 'buyer_query',
        language: {
          code: 'en_US',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                text: sellerName || 'default name',
              },
              {
                type: 'text',
                text: productName,
              },
              {
                type: 'text',
                text: this.messsage,
              },
              {
                type: 'text',
                text: `${this.profileInfo2?.countryCode
                  ? this.profileInfo2.countryCode
                  : '+65'
                  }${this.profileInfo2.phone}`,
              },
            ],
          },
        ],
      },
    };

    const token = environment.whtsappCloudToken;

    await fetch(environment.whtsappCloudUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    this.auth
      .syncBooking({
        productId: this.productData.id,
        type: 1,
      })
      .subscribe((response: any) => {
        this.productData.remainingBook.push(response.body.bookings);
      });
    this.isLoading = false;
    this.isMessageBox = false;
    this.isMessageSent = true;
    setTimeout(() => {
      this.isMessageSent = false;
    }, 2000);
  }
  public get showReferProductIcon(): boolean {
    if (this.linkRfererUserId) {
      return false;
    }
    return this.productData?.productMoreServices?.find(s => {
      ////////console.log(s)
      return s.allowRefer
    }
    );
  }
  private getMoreServiceRefferalLink(productData) {
    const user = this.local.getUser();
    const origin = window.location.host;
    return `${origin}/product/${productData?.slug}-${user.id}&promo=1`;

  }

  public async copy(s: string) {
    try {
      await navigator.clipboard.writeText(s);
      this.toastr.success("Copied!")
    } catch (e) {
      this.toastr.error("Error while copying")
    }

  }

  public openShareReferLink(productData) {
    const user = this.local.getUser();
    if (!user) {
      this.toastr.error("Please login first!")
      return;
    }
    const link = this.getMoreServiceRefferalLink(productData)

    const ref = this.modalService.open(LinkShareComponent, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
    })
    ref.componentInstance.linkToBeShared = link;
    ref.componentInstance.title = 'Copy Referal Link '
  }

  public get showTelegramButton(): boolean {
    if (this.window.location.href.includes('/biz')) {
      return !!this.productData?.seller?.w_phone_number?.trim();
    }
    return (
      this.productData?.seller?.allowTelegramContact === 1 &&
      this.productData?.seller?.w_phone_number && this.productData?.seller?.buyerContact != 0 //this is since old data might allowed bot telegram and whatsapp to be turned on
    );
  }
  public get showChatNow(): boolean {
    if (!this.isPageBiz) {
      return true;
    }
    return this.productData?.bizHasBot;
  }

  remainingClickBook(type = 0) {
    const data = this.productData.remainingBook?.filter(
      (row: any) => row?.type == type
    );
    return 3 - (data?.length ?? 0);
  }

  async onChangeMessage(e: any) {
    this.messsage = e.target.value;
  }

  redirectLink(bypass = false) {
    //////console.log("opening link")
    const url = 'https://wa.me/' + (this.productData?.type == 'promote' ? this.productData?.shoutContact : this.productData?.seller?.w_phone_number);

    if (bypass || !this.productData?.enableMemberShop) {
      Swal.fire({
        icon: 'info',
        text: `This will open direct WhatsApp link`,
        showCancelButton: true,
        confirmButtonColor: 'var(--primary)',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
      }).then((resp) => {
        if (resp.isConfirmed) {
          this.window.open(url, '_blank');
        }
      });
      return;
    }
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }

    const isLogin = this.local.getUser();
    if (!isLogin) return this.toastr.error('Please Login First!');

    const user = this.productData.appUser ?? this.productData.seller;

    if (isLogin.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    this.errorChatURL = false;

    if (url != '' && url != null) {
      const detail = this.productData;
      const typeFilter = 1;
      const check = detail.remainingBook.filter(
        (row: any) => row.productId == detail.id && row?.type == typeFilter
      );

      if (detail.remainingBook.length > 5) {
        this.toastr.error(
          'you have reached the maximum limit for sending messages'
        );
        return false;
      }

      if (this.remainingClickBook(typeFilter) == 0) {
        this.toastr.error(
          'you have reached the maximum limit for sending messages'
        );
        return false;
      }

      if (check.length > 0) {
        this.toastr.error('You can only message this person once per day');
        return false;
      }
      return Swal.fire({
        text: `This will open direct WhatsApp link (${this.remainingClickBook(
          1
        )})`,
        showCancelButton: true,
        confirmButtonColor: 'var(--primary)',
        cancelButtonColor: '#d33',
        confirmButtonText: 'OK',
      }).then((resp) => {
        if (resp.isConfirmed) {
          this.window.open(url, '_blank');
          this.auth
            .addChatNotification(
              (this.productData.appUser ?? this.productData.seller).id,
              'whatsapp'
            )
            .subscribe({
              next: () => { },
            });
          this.auth
            .syncBooking({
              productId: this.productData.id,
              type: 1,
            })
            .subscribe((response: any) => {
              this.productData.remainingBook.push(response.body.bookings);
            });
        }
      });
    } else this.errorChatURL = true;
    this.errorChatURL = this.errorChatURL;
  }

  public submitReport(): void {
    if (this.isLogin == 0) {
      this.toastr.error('Please Login First !');
      return;
    }

    let message = this.memberMessage.trim();
    if (message) {
      let payload: any = {
        message: message,
        product_id: this.productData.id,
        type: this.type,
        category: 'biz_product',
      };
      if (this.productData?.enableMemberShop) {
        payload = {
          message: message,
          member_product_id: this.productData.id,
          type: this.type != '' ? this.type : this.reportType,
          category: 'product',
        };
      }

      const user = this.productData?.appUser ?? this.productData?.seller;
      payload.sellerId = user?.id;

      this.auth.submitReportMessage(payload).subscribe((response: any) => {
        this.toastr.success(response.message);
        this.modalRef.close();
        this.type = '';
        this.memberNotificationService.getNotification();
      });
    } else {
      this.toastr.error('Report is empty!');
    }
  }

  openSuggestModal(modal: any, type: any = '') {
    this.memberMessage = '';
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
    this.type = type;
  }

  openReportModal(modal: any, type: any = '') {
    this.memberMessage = '';
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
    this.type = type;
  }

  saveSeletedImage(event) {
    let file = event.target.files[0];

    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.suggestionBase64 = fileReader.result;
      this.suggestionAttachment = file;
    };
    fileReader.readAsDataURL(file);
  }

  modalDismissAll() {
    this.modalService.dismissAll();
  }

  private get isPageBiz(): boolean {
    return this.window.location.href.includes('/biz');
  }

  public openTelegramAccount(phoneNumber: string | number) {
    if (!phoneNumber) {
      console.error('empty phoner number given!');
      return;
    }
    if (typeof phoneNumber != 'number' && typeof phoneNumber != 'string') {
      console.error('invalid type!');
      return;
    }
    this.window.open(
      `https://t.me/${this.isPageBiz ? '' : '+65'}${phoneNumber}`,
      '_blank'
    );
  }
  async handleTelegram(itemId) {
    const isLogin = this.local.getUser();
    if (!isLogin) return this.toastr.error('Please Login First!');

    const user = this.productData.appUser ?? this.productData.seller;

    if (isLogin.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    this.auth
      .addChatNotification(
        (this.productData.appUser ?? this.productData.seller).id,
        'book-now'
      )
      .subscribe({
        next: () => { },
      });

    const modalRef: NgbModalRef = this.modalService.open(
      BookTimingModalComponent,
      {
        windowClass: 'my-modal sm book-timing',
        size: 'sm',
      }
    );
    modalRef.componentInstance.productData = this.productData;

    const productDataChangeListener = () => {
      modalRef.componentInstance.productData = this.productData;
    };
    this.onChangeListeners.push(productDataChangeListener);
    const dismissFunc = () => {
      const idx = this.onChangeListeners.indexOf(productDataChangeListener);
      if (idx !== -1) {
        this.onChangeListeners.splice(idx, 1);
      }
    };

    modalRef.closed.subscribe(dismissFunc);
    modalRef.dismissed.subscribe(dismissFunc);

    // await this.telegramPost(itemId)
    //this.modal.close();e
  }

  // async telegramPost(itemId) {

  //   const login = this.local.getUser();

  //   if (!login) return this.toastr.error('Please Login First!');

  //   const user = this.productData?.appUser ?? this.productData?.seller;
  //   if (login.id == user?.id) {
  //     this.toastr.error("It's your product")
  //     return
  //   }
  //   const token = login.token;
  //   const URL = environment.ImageUrl+ 'api/postToTelegramChannels';
  //   // await fetch(URL, {method: 'POST'})
  //   this.http.post(URL, {
  //     itemId
  //   }, {
  //     headers: {
  //       'Authorization': `Bearer ${token}`
  //     }
  //   })
  //   .subscribe(
  //     data =>{
  //        this.toastr.show("Posted!")
  //     },
  //     err =>{
  //       this.toastr.error("Error: " + err.error.error)
  //     }
  //   )

  // }

  openChat(params) {
    this.sharedService.triggerChatNow(params);
  }

  async handleChatNow() {
    const isLogin = this.local.getUser();
    if (!isLogin) return this.toastr.error('Please Login First!');

    const user = this.productData.appUser ?? this.productData.seller;

    if (isLogin.id == user?.id) {
      this.toastr.error("It's your product");
      return;
    }
    this.modalDismissAll();
    const params = {
      chatingNow: user?.id,
      menu: 'chat',
      chatTitle: user.profileCharacterName ?? 'User',
      lastSeenTime: user.lastSeenTime ?? '...',
      productName: this.productData.name,
      productImage: this.productData.food_image_active,
      productPrice: this.productData.costPrice,
      productId: this.productData.id,
      isBiz: this.window.location.href.indexOf('/biz') != -1,
      isFirstMessageFromChatNow: window.location.href.indexOf('/biz') == -1,
    };

    if (this.window.location.href.indexOf('/biz') != -1) {
      this.auth.get_chat_data(user?.id, true).subscribe({
        next: (data) => {
          if (data['chatData']['doesBizHaveABot']) {
            this.openChat(params);
          } else {
            this.toastr.info('Biz Owner has not registered a telegram account');
          }
        },
        error: (err) => {
          this.toastr.error('Something went wrong please try again latter');
        },
      });
    } else {
      this.openChat(params);
    }

    //this.sharedService.triggerChatNow({ chatingNow: user?.id, menu: 'chat', chatTitle: user.profileCharacterName ?? "User" });
    // this.auth
    //   .chatCheckChannel({
    //     sellerId: user.id,
    //     productId: this.productData.id,
    //   })
    //   .subscribe((response: any) => {
    //     const result = response.body;
    //     this.modalDismissAll();
    //     this.sharedService.triggerChatNow({ menu: 'chat' });
    //     this.productData['foodSpecs'] =
    //       this.productData?.memberShopProductsVariations || [];

    //     const resultsConverter = {
    //       name: this.productData.name,
    //       description: this.productData.description,
    //       seller_info: this.productData.seller_info,
    //       delivery: this.productData.delivery,
    //       image: this.productData.memberShopProductsImages[0].image,
    //       sellerName: user.profileCharacterName ?? 'Admin Shop',
    //       sellerImage: user.profileCharacterImageFile ?? 'Admin Shop',
    //       variations: this.productData.foodSpecs.map((row: any) => {
    //         return {
    //           price: row.key,
    //           name: row.value,
    //           currency: '$',
    //           unit: row.nKey,
    //         };
    //       }),
    //     };

    //     setTimeout(() => {
    //       this.sharedService.triggerInitSeller({
    //         ...this.productData.appUser,
    //         channel: result,
    //         product_name: this.productData.name,
    //         product_image: this.imgUrl + this.productData?.primaryImage,
    //         params: {
    //           seller_id: user.id,
    //           product_id: this.productData.id,
    //           query: 'Send me price list for this product',
    //           product_details: JSON.stringify(resultsConverter),
    //         },
    //       });
    //     }, 100);
    //   });
  }

  //************************* Code related to adding new promo on a product ***********/
  public isAddPromoVisible = false
  @ViewChild('addAdsInProduct')
  public addAdsInProduct: TemplateRef<any>
  public currentlyAddingPromoToProduct = null;
  public openAdInProductModal(pd) {
    this.currentlyAddingPromoToProduct = pd;
    this.modalService.open(this.addAdsInProduct);
  }
  private _resetNewPromoFields(): void {
    this.newPromoServiceComment = null;
    this.newPromoServiceDescription = '';
    this.newPromoIconText = null;
    this.newPromoExpiryInString = null;
    this.newPromoAllowRefer = null;
    this.newPromotReferAmount = null;
    this.encodedMorePromoBuffer = null;
  }

  public newPromoServiceComment = '';
  public newPromoServiceDescription = ''
  public newPromoIconText = '';
  public newPromoExpiryInString = '1 Week';
  public newPromoAllowRefer = 0;
  public newPromotReferAmount = 0
  public encodedMorePromoBuffer = null;

  public moreServiceIcons = [
    'fa-solid fa-crown',
    'fa fa-thumbs-up',
    'fas fa-gem',
    "fa-solid fa-lightbulb",
    "fa-solid fa-trophy",
    "fa-solid fa-fire",
    "fa-solid fa-medal",
    "fa-solid fa-heart",
    "fa-solid fa-trophy",
    "fas fa-bolt"
  ]
  public readonly newPromoImageSelectorId = 'newPromoImageSelector';
  public selectMoreImageNewPromoImage() {
    document.getElementById(this.newPromoImageSelectorId).click()
  }
  public newPromoSelectedImage = null;
  public newPromotSelectedImageConverted = null;;
  public deleteNewPromoImage() {
    this.newPromoSelectedImage = null;
    this.newPromotSelectedImageConverted = null;
  }
  public setImageOfMoreService(event,) {
    if (!event.target.files || !event.target.files.length) {
      this.deleteNewPromoImage();
      return;
    }
    const file = event.target.files[0];

    this.newPromoSelectedImage = file;
    const reader = new FileReader();
    reader.onload = () => {
      this.newPromotSelectedImageConverted = reader.result;
    }
    reader.readAsDataURL(file);

  }
  public readonly newPromoImageAttachName = 'imgMoreService1'
  public expiryStringChanged(event, i) {
    const value = event.target?.value;
    this.newPromoExpiryInString = value
  }
  private getImageByAccessor(images, accessor) {
    const imageObj = images?.find((o) => o.imageAccessor === accessor);
    return imageObj ? imageObj.image : "";
  };

  private loadOtherImagesOfProduct(productData) {
    ////console.log('getting of', productData.name, productData.memberShopProductsImages)
    productData["foodSpecs"] = productData?.memberShopProductsVariations || [];
    productData["food_image_1"] = this.getImageByAccessor(productData.memberShopProductsImages, "image1");
    productData["food_image_active"] = productData["food_image_1"];
    productData["food_image_2"] = this.getImageByAccessor(productData.memberShopProductsImages, "image2");
    productData["food_image_3"] = this.getImageByAccessor(productData.memberShopProductsImages, "image3");
    productData["food_image_4"] = this.getImageByAccessor(productData.memberShopProductsImages, "image4");


  }
  public availableExpiryIntervals = ['1 Week', '1 Month', '2 Month']
  public saveNewPromoOnProduct() {
    const fd = new FormData()
    const payload = {
      serviceComment: this.newPromoServiceComment,
      serviceDescription: this.newPromoServiceDescription,
      iconText: this.newPromoIconText,
      expiryInString: this.newPromoExpiryInString,
      allowRefer: this.newPromoAllowRefer,
      referAmount: this.newPromotReferAmount,
      imageAttachName: this.newPromoImageAttachName
    }
    for (const payloadField in payload) {
      fd.append(payloadField, payload[payloadField])
    }
    fd.append('productId', this.currentlyAddingPromoToProduct?.id)
    fd.append(this.newPromoImageAttachName, this.newPromoSelectedImage);


    this.auth.addPromoOnProduct(fd).subscribe({
      next: () => {
        this.toastr.success("Promo Added!");
        this._resetNewPromoFields();
        this.modalService.dismissAll();
      },
      error: err => {
        console.error(err);
        this.toastr.error(err.error.message)
      }
    });


  }

  /********************************************************************************** */

  openMemberLinkPopup(e: any, modal, foodId, type) {
    e.preventDefault();
    this.isTypeReferral = type;
    if (this.isLogin == 1) {
      this.modalRef = this.modalService.open(modal, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'member_link_pop',
      });
      this.get_marketplace_referral_store_link(foodId, type);
    } else {
      if (type == 'referral') {
        this.toastr.warning('Please login to open referral link.');
      } else {
        this.toastr.warning('Please login to open store link.');
      }
    }
  }

  get_marketplace_referral_store_link(foodId, type) {
    (this.productData?.enableMemberShop
      ? this.auth.getMarketplaceReferralStoreLink(foodId)
      : this.auth.get_marketplace_referral_store_link(foodId)
    ).subscribe(
      (response: any) => {
        if (response.body.isStoreLink == 1) {
          this.store_link_prefix = response.body.referFriendLink;
          this.createReferralLink(
            response.body.clientId,
            response.body.appUserId,
            type,
            this.store_link_prefix
          );
        } else {
          this.store_link_prefix = this.default_store_link_prefix;
          this.createReferralLink(
            response.body.clientId,
            response.body.appUserId,
            type,
            this.store_link_prefix
          );
        }
      },
      (e) => {
        if (e.status == 400) {
          //this.toastr.error(e.error.message);
        }
      }
    );
  }

  createReferralLink(clientId, appUserId, type, storeLinkPrefix) {
    let urlParams = '';
    if (type == 'referral') {
      urlParams = `referral_${clientId}_${appUserId}`;
    } else {
      urlParams = `normal_${clientId}`;
    }
    const urlParamsEnc = CryptoJS.AES.encrypt(
      urlParams,
      'shop-web-links'
    ).toString();
    const urlParamsEncUrl = encodeURIComponent(urlParamsEnc);
    const urlOrigin = `https://${storeLinkPrefix}/#/mobile/${urlParamsEncUrl}`;
    this.refer_friend_link = urlOrigin;
  }

  public isSelected(date: NgbDateStruct): boolean {
    return this.productData?.selectedHolidays
      ? this.productData?.selectedHolidays.some((d) => this.dateEquals(d, date))
      : false;
  }

  dateEquals(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return (
      date1.year === date2.year &&
      date1.month === date2.month &&
      date1.day === date2.day
    );
  }

  handleHideProduct() {
    this.checkIfLogin();
    if (this.productData?.hiddenBy.includes(this.appUserId)) {
      this.toastr.error('maximum 1 time for request');
      return;
    }
    this.local
      .alertConfirm({
        message: `Are you sure want to hide this product ?`,
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.local.alertLoading({});
          this.auth
            .hideMemberShopProduct({ productId: this.productData?.id })
            .subscribe(
              (resp: any) => {
                Swal.close();
                this.toastr.success(resp.message);
                this.productData?.hiddenBy.push(this.appUserId);
                // if(this.productData?.hiddenBy?.length >= 5) {

                // }
              },
              (e) => {
                Swal.close();
                // this.toastr.error(e.error.message)
              }
            );
        }
      });
  }

  public editMemberProduct() {
    if (this.addProductComponent) {
      this.addProductComponent.memberShopProductType = this.productData?.type;
      this.addProductComponent.selectedCatId = this.productData?.categoryId;
      this.addProductComponent.selectedCategoryNameForDD =
        this.productData?.categoryName;
      this.addProductComponent.selectedsubCatId =
        this.productData?.subCategoryId;
      this.addProductComponent.selectedSubCategoryName =
        this.productData?.subCategoryName;
      this.addProductComponent.editProductModal(this.productData?.id);
    }
  }

  public deleteMemberProduct() {
    this.addProductComponent.delete_food(this.productData?.id);
  }

  openBizLink(isPromote = false) {
    if (isPromote) {
      window.open(this.hrefContact(this.productData.shoutLink), '_blank');
      return
    }


    if (this.productData?.seller?.shop_name == 'null' || this.productData?.seller?.shop_name == '') {
      this.productData.seller.shop_name = null;
    }
    this.router.navigate(['/biz/shop', (this.productData?.adminId)]);
  }

  public priceCheck(value) {
    return parseFloat(value) ? '$' + parseFloat(value) : '';
  }

  public showLoginErr = false; //login error should not be shown immediatly but when there is come
  public loginErrorReason = '';
  showLoginError(reason) {
    this.loginErrorReason = reason;
    this.showLoginErr = true;

    document.getElementById('login-err').scrollIntoView();
  }

  loginHere() {
    //this.modalService.dismissAll();
    document.getElementById('loginBtn').click();
    this.showLoginErr = true;
    // this.auth.increaseLoginBecauseOfProductCount(this.productData.id).subscribe({
    //   error: console.error,
    //   next:  () => //////console.log("login count increased")
    // })
  }

  selectedAttachProduct: any = null;
  public attachMemberProduct(modal: any, productId: any): void {
    if (!this.productData.attachmentProducts) {
      this.selectedAttachProduct = productId;
      this.modalRef = this.modalService.open(modal, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'suggestion',
      });
      this.getMemberProductList();
    } else {
      this.toastr.error('Only one product can be added!');
    }
  }

  public attachProduct(productId: any) {
    if (this.selectedAttachProduct == productId) {
      this.toastr.error('Both Product Cannot b same!');
      return;
    }

    this.endTime = this.endTime
      ? moment(new Date()).add(parseInt(this.endTime), 'days').valueOf()
      : '';
    let payload = {
      parentProductId: this.selectedAttachProduct,
      childProductId: productId,
      description: '',
    };
    if (this.endTime) {
      payload['attachmentEndTime'] = this.endTime;
    }

    this.auth.addProductsAttachment(payload).subscribe((response: any) => {
      this.modalRef ? this.modalRef.close() : '';
      this.toastr.success(response.message);
      this.memberNotificationService.clearNotification();
      this.productData['attachmentProducts'] = productId;
    });
  }
  public submitSuggestion() {
    if (this.isLogin == 0) {
      return this.toastr.error('Please Login First !');
    }
    let formData = new FormData();
    let message = this.memberMessage.trim();
    formData.append('message', message);
    this.productData?.enableMemberShop
      ? formData.append('member_product_id', this.productData.id)
      : formData.append('product_id', this.productData.id);
    formData.append('type', this.type);

    if (message) {
      this.auth.submitSuggestionMessage(formData).subscribe((response: any) => {
        this.type = '';
        this.toastr.success(response.message);
        this.modalRef.close();
      });
    } else {
      this.toastr.error('Suggestion is empty!');
    }
  }

  shareContent() {
    if (navigator.share) {
      // Get the image URL from the img element
      const imgElement = document.querySelector('img.main-image');
      //@ts-ignore
      const imgUrl = imgElement?.src;

      if (imgUrl) {
        // Fetch the image from the URL and convert it to a blob
        fetch(imgUrl)
          .then((res) => res.blob())
          .then((blob) => {
            // Create a file from the blob
            const file = new File([blob], 'image.jpg', { type: 'image/jpeg' });

            // Now share the file along with other details
            navigator
              .share({
                title: this.productData?.name || 'Check this out!',
                text: '',//text: this.getRating() || 'See this amazing product!',
                url: this.window.location.href || '', // The URL you want to share
                files: [file], // Attach the image file
              })
              .then(() => {
              })
              .catch((error) => {
                // console.error('Error sharing:', error);
              });
          })
          .catch((error) => {
            // console.error('Error fetching the image:', error);
          });
      } else {
        // console.error('Image not found');
      }
    } else {
      alert('Web Share API is not supported in your browser.');
    }
  }

  public getRating(): string {
    let rating = '';
    if (
      this.productData?.sellerInformation?.googleReviewRating ||
      this.productData?.sellerInformation?.googleReviewCount ||
      this.productData?.sellerInformation?.googleReviewCount
    ) {
      rating +=
        (this.productData?.sellerInformation?.googleReviewRating + ' Star' ||
          '') +
        ' Google ' +
        (this.productData?.sellerInformation?.googleReviewCount
          ? '(' + this.productData?.sellerInformation?.googleReviewCount + ')'
          : '');
    }

    if (
      this.productData?.sellerInformation?.carousellReviewRating ||
      this.productData.sellerInformation?.carousellReviewCount ||
      this.productData?.sellerInformation?.carousellReviewCount
    ) {
      rating +=
        (this.productData?.sellerInformation?.carousellReviewRating + ' Star' ||
          '') +
        'Carousell ' +
        (this.productData.sellerInformation?.carousellReviewCount
          ? '(' +
          this.productData?.sellerInformation?.carousellReviewCount +
          ')'
          : '');
    }

    return rating;
  }

  public get verifiedStyle() {
    const len = this.verifiedTag?.length;

    return `position: relative; left: ${(len * 0.08 + 2)}rem; gap: .4em;`;
  }
  public get verifiedTag() {
    return ((this.productData?.verifiedTag?.trim()?.length ? this.productData.verifiedTag : "Verified").toLowerCase())
  }

  public openHolidayPopUp(modal) {
    this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'suggestion',
    });
  }

  public isArray(input) {
    return Array.isArray(input);
  }

  public goToProfileDetail() {
    if (this.productData?.appUser?.profileCharacterName == 'null' || this.productData?.appUser?.profileCharacterName == '') {
      this.productData.appUser.profileCharacterName = null
    }
    this.router.navigateByUrl(
      `/community/profile/${this.productData?.appUser?.profileCharacterName ?? this.productData?.appUser?.referralCode}`
    );
  }

  public redirectToProduct(input) {
    let currentUrl = this.productData.enableMemberShop ? '/community' : '/biz';
    let product = input?.name.trim().toLowerCase().replace(/ /g, "-")


    this.router.navigateByUrl(
      `/${currentUrl}?product=${product}-${input?.id}`
    );
  }

  openRecommendation(pin) {
    this.sharedService.triggerOpenExperience(pin)
  }

  hrefContact(url: string) {
    if (!url.startsWith('https')) {
      url = url.replace('http://', 'https://');
    } else if (!url.startsWith('https') && !url.startsWith('http')) {
      url = 'https://' + url;
    } else if (url.startsWith('https//')) {
      url = url.replace('https//', 'https://');
    } else if (url.startsWith('http//')) {
      url = url.replace('http//', 'https://');
    }
    return url;
  }

  public handleSupportSeller() {
    if (!this.isLogin) {
      this.toastr.error('Please Login First!');
      return;
    }
    this.local
      .confirm({
        title: 'Support',
        text: `Do you wish to Support this business?`,
        icon: 'info',
      })
      .then((resp) => {
        if (resp.isConfirmed) {
          this.customerService
            .addMemberSupport({
              businessId: this.productData?.appUser?.id,
              type: 'community',
            })
            .subscribe({
              next: (response: any) => {
                this.productData.appUser.isSupport = !this.productData.appUser.isSupport
                this.toastr.success(response.message);
              },
              error: (e) => {
                this.toastr.error(e.error.message);
              },
            });
        } else {
          this.toastr.info('Support cancelled');
        }
      });
  }
}
